import { makeStyles } from "@material-ui/core/styles";
import { warning, primary } from "../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: "40vw",
    maxWidth: "60vw",
  },
  row: {
    padding: `${theme.spacing(1)}px 0`,
  },
  checkboxContainer: {
    paddingLeft: "0px",
    paddingRight: "4px",
  },
  checkboxText: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "16px",
    cursor: "pointer",
  },
  icon: {
    color: warning,
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
  },
  buttonRow: {
    "& button": {
      margin: `0 ${theme.spacing(0.5)}px`,
    },
  },
  bullet: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: primary,
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.75),
  },
}));

export default useStyles;
